import { FunctionComponent, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import HeaderSection from "../components/header-section"
import ProgressDialogBox from "../components/progress-dialog-box"
import { StepComponent } from "../components/progress-steps"
import Sidebar from "../features/sidebar/components/sidebar"
import { setUserCompletedTutorial } from "../features/auth/authSlice"
import { resetSimulationState } from "../features/simulation/utils"
import { simulationSlice } from "../features/simulation/simulationSlice"
import { useTypedDispatch } from "../app/store"

const tutorialDescription = `Welcome to your Meseekna Simulation Experience! This tutorial
                will guide you through the key features of the simulation
                platform with a sample scenario. You can replay this tutorial as
                many times as you need to.`

const TutorialIntro: FunctionComponent = () => {
  const navigate = useNavigate()
  const dispatch = useTypedDispatch()
  const { testId, runId } = useParams()

  const navigateToTutorial = () => {
    resetSimulationState(dispatch, false)
    dispatch(setUserCompletedTutorial(false))
    navigate(`/simulations/${testId}/${runId}/tutorial`)
  }

  const navigateToScenario = () => {
    resetSimulationState(dispatch, false)
    dispatch(setUserCompletedTutorial(true))
    navigate(`/simulations/${testId}/${runId}/intro`)
  }

  const buttons = [
    {
      text: "Start Tutorial",
      callback: navigateToTutorial,
    },
    {
      text: "Skip to Simulation Experience",
      callback: navigateToScenario,
    },
  ]

  useEffect(() => {
    dispatch(simulationSlice.actions.changeSteps(0))
    if (!testId && !runId) {
      navigate("/dashboard")
    }
  }, [])

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection hideBreadcrumbs hideHelpIcon hideProfileIcon />
        <div>
          <StepComponent />
          <ProgressDialogBox
            title="Tutorial"
            text={tutorialDescription}
            buttons={buttons}
          />
        </div>
      </div>
    </div>
  )
}

export default TutorialIntro
